import { render, staticRenderFns } from "./Myhedaer.vue?vue&type=template&id=387517b8&scoped=true&"
import script from "./Myhedaer.vue?vue&type=script&lang=js&"
export * from "./Myhedaer.vue?vue&type=script&lang=js&"
import style0 from "./Myhedaer.vue?vue&type=style&index=0&id=387517b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387517b8",
  null
  
)

export default component.exports